import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const index = r => require.ensure([], () => r(require('src/pages/index')), 'index')
const special = r => require.ensure([], () => r(require('src/pages/special')), 'special')
const hard = r => require.ensure([], () => r(require('src/pages/hard')), 'hard')
const speed = r => require.ensure([], () => r(require('src/pages/speed')), 'speed')
const practice = r => require.ensure([], () => r(require('src/pages/practice')), 'practice')
const member = r => require.ensure([], () => r(require('src/pages/member')), 'member')
const mock = r => require.ensure([], () => r(require('src/pages/mock')), 'mock')
const papers = r => require.ensure([], () => r(require('src/pages/papers')), 'papers')
const gufen = r => require.ensure([], () => r(require('src/pages/gufen')), 'gufen')

const article = r => require.ensure([], () => r(require('src/pages/article')), 'article')
const report = r => require.ensure([], () => r(require('src/pages/article/report')), 'report')
const demoReport = r => require.ensure([], () => r(require('src/pages/article/demo-report')), 'demoReport')
const detail = r => require.ensure([], () => r(require('src/pages/detail')), 'detail')

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      redirect: '/practice'
    },
    {
      path: '/paper',
      redirect: '/practice'    
    },
    {
      path: '/special',
      component: special
    },
    {
      path: '/hard',
      component: hard
    },
    {
      path: '/speed',
      component: speed
    },
    {
      path: '/practice',
      component: practice
    },
    {
      path: '/member',
      // redirect: '/practice' 
      component: member 
    },
    {
      path: '/mock',
      component: mock
    },
    {
      path: '/papers',
      component: papers
    },
    {
      path: '/gufen',
      redirect: '/practice' 
    },
    {
      path:'/article/:uid',
      component:article
    },
    {
      name:'report',
      path:'/report/:mid',
      component:report
    },
    {
      path:'/demo_report/:mid',
      component:demoReport
    },
    {
      path:'/detail/:rank/:id',
      component:detail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js